import type { LotSizing } from '@/types/core/lot-sizing/lot-sizing';

export function hasRelatedPurchaseOrders(
  lotSizing: Pick<LotSizing, 'purchaseOrders'> | null | undefined,
): boolean {
  return (lotSizing?.purchaseOrders.length ?? 0) > 0;
}
